<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-0 pt-5 pt-md-3"
    ></base-header>
    <div class="container-fluid mt-3">
      <tabs :fill="false" class="flex-column flex-md-row">
        <div>
          <!-- all business -->
          <tab-pane>
            <span slot="title">
              <i class="ni ni-cloud-upload-96"></i>
              All Businesses
            </span>

            <!-- all businesses table -->
            <div class="row">
              <div class="col">
                <div class="card shadow">
                  <div
                    class="card-header border-0"
                    style="background-color: #f9f9f9"
                  >
                    <div class="row align-items-center">
                      <div class="col-2">
                        <p class="mb-0">
                          Filter Business
                        </p>
                      </div>

                      <div class="col-2">
                        <select
                          aria-describedby="addon-right addon-left"
                          v-model="modals.filter_business_type"
                          class="form-control form-control-alternative"
                          autocomplete="off"
                          @change="onFilterBusinessTypeChange()"
                        >
                          <option value="">All Types</option>
                          <option value="Designer">Designer</option>
                          <option value="Supplier">Supplier</option>
                          <option value="Designer + Supplier">Both</option>
                        </select>
                      </div>

                      <div class="col-3">
                        <select
                          v-if="shouldShowCategorySelect"
                          :key="
                            `category-select-${
                              modals.filter_business_type
                            }-${categorySelectKey}`
                          "
                          aria-describedby="addon-right addon-left"
                          v-model="modals.business_category"
                          class="form-control form-control-alternative"
                          autocomplete="off"
                          @change="getsubcategories($event)"
                        >
                          <option value="" disabled>Select category</option>
                          <option
                            v-for="category in filteredCategories"
                            :value="category._id"
                            :key="category._id"
                          >
                            {{ category.business_category_name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-2">
                        <select
                          aria-describedby="addon-right addon-left"
                          v-model="modals.business_subcategory"
                          class="form-control form-control-alternative"
                          autocomplete="off"
                          @change="filterbusiness()"
                        >
                          <option value="">Select sub-category</option>
                          <option
                            v-for="subcategory in subcategories"
                            :value="subcategory._id"
                            :key="subcategory.business_subcategory_name"
                          >
                            {{ subcategory.business_subcategory_name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-2">
                        <select
                          aria-describedby="addon-right addon-left"
                          class="form-control form-control-alternative"
                          autocomplete="off"
                          @change="filtercitybusiness()"
                          v-model="modals.business_city"
                        >
                          <option value="" disabled="">Select city</option>
                          <option
                            v-for="city in cities"
                            :value="city.value_en"
                            :key="city.value_en"
                          >
                            {{ city.value_en + '(' + city.value_ar + ')' }}
                          </option>
                        </select>
                      </div>
                      <div class="col-1 text-right">
                        <a
                          @click="cleardata()"
                          class="btn btn-sm btn-primary text-white"
                          >Clear</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="container mt-3" v-if="!deleteitem">
                    <div class="row pb-4">
                      <div
                        v-bind:key="index"
                        class="col-lg-4 mb-2"
                        v-for="(business, index) in businessData"
                      >
                        <div>
                          <article class="card mb-2">
                            <div class="business-image">
                              <img
                                v-if="!business.cover_image"
                                src="img/noimage.png"
                                alt="Image"
                                class="card-img-top"
                              />
                              <img
                                v-if="business.cover_image"
                                :src="business.cover_image"
                                alt="Image"
                                class="card-img-top"
                              />
                            </div>
                            <div class="card-body">
                              <h4 class="card-title">
                                {{ business.business_name_english }}
                              </h4>
                              <a
                                target="_self"
                                :href="'#/viewbusiness/' + business.user_id"
                                class="btn btn-sm btn-primary"
                                ><i class="fa fa-briefcase"></i> View
                                Business</a
                              >
                              <base-button
                                type="danger"
                                size="sm"
                                @click="deletebusiness(business)"
                                icon="fa fa-trash"
                                >Delete</base-button
                              >
                              <a
                                target="_self"
                                :href="'#/editbusiness/' + business.user_id"
                                class="btn btn-sm btn-primary"
                                ><i class="fa fa-pencil"></i> Edit</a
                              >

                              <!--  <base-button type="primary" size="sm" @click="openbusiness(business)" icon="fa fa-pencil">Edit</base-button> -->
                              <!-- <base-button type="danger" size="sm" @click="deletebusiness(business)" icon="fa fa-pencil">Delete</base-button> -->
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer d-flex justify-content-end"
                    v-if="!deleteitem"
                  >
                    <nav aria-label="Page navigation example">
                      <ul class="pagination">
                        <li class="page-item">
                          <a class="page-link" @click="previouspage()">
                            <span aria-hidden="true"
                              ><i
                                aria-hidden="true"
                                class="fa fa-angle-left"
                              ></i
                            ></span>
                          </a>
                        </li>
                        <li class="page-item d-flex">
                          <p class="mb-0 px-1">
                            PAGE
                          </p>
                          <input
                            size="4"
                            class="mx-1 p-2 text-center"
                            style="border: 1px solid #e9ecff;border-radius: 5px !important;background-color: #e9ecff;width: 4em;"
                            type="number"
                            name="page_no"
                            id="page_no"
                          />
                          <base-button
                            block
                            type="primary"
                            class="px-3 mx-1"
                            title="GO"
                            size="sm"
                            @click="gotopage()"
                            >GO</base-button
                          >
                        </li>
                        <li class="page-item">
                          <a @click="nextpage()" class="page-link">
                            <span aria-hidden="true"
                              ><i
                                aria-hidden="true"
                                class="fa fa-angle-right"
                              ></i
                            ></span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="row" v-if="deleteitem">
                    <div class="col-lg-12">
                      <article class="card mb-2">
                        <center>
                          <div class="col-5">
                            <div>
                              <img
                                src="img/dashboard_no_item.jpg"
                                alt="Image"
                                class="card-img-top"
                              />
                            </div>
                            <a @click="cleardata()">
                              <base-button
                                type="primary"
                                size="lg"
                                block
                                class="mb-5 mt-3"
                                icon="fa fa-image"
                                >Clear Search</base-button
                              >
                            </a>
                          </div>
                        </center>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
          <!-- search business -->
          <tab-pane>
            <span slot="title">
              Search Businesses
            </span>

            <!-- search business table -->
            <div class="row">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div
                    class="card-header border-0"
                    :class="type === 'dark' ? 'bg-transparent' : ''"
                  >
                    <div class="row align-items-center">
                      <div class="col-md-12 d-flex text-center">
                        <div class="col-md-2"></div>
                        <div class="col-md-6">
                          <base-input
                            alternative=""
                            class="mb-0"
                            label=""
                            placeholder="Search business"
                            input-classes="form-control-alternative"
                            v-model="search"
                          />
                        </div>
                        <div class="col-md-1">
                          <base-button
                            class="ml-2"
                            type="primary"
                            id="updatebtn"
                            v-on:click="searchbusiness()"
                            >Search</base-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container" v-if="!sdeleteitem">
                    <div class="row pb-4">
                      <div
                        v-bind:key="index"
                        class="col-lg-4 mb-2"
                        v-for="(business, index) in searchData"
                      >
                        <div>
                          <article class="card mb-2">
                            <div class="business-image">
                              <img
                                v-if="!business.cover_image"
                                src="img/noimage.png"
                                alt="Image"
                                class="card-img-top"
                              />
                              <img
                                v-if="business.cover_image"
                                :src="business.cover_image"
                                alt="Image"
                                class="card-img-top"
                              />
                            </div>
                            <div class="card-body">
                              <h4 class="card-title">
                                {{ business.business_name_english }}
                              </h4>
                              <a
                                target="_self"
                                :href="'#/viewbusiness/' + business.user_id"
                                class="btn btn-sm btn-primary"
                                ><i class="fa fa-briefcase"></i> View
                                Business</a
                              >
                              <base-button
                                type="danger"
                                size="sm"
                                @click="deletebusiness(business)"
                                icon="fa fa-trash"
                                >Delete</base-button
                              >
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="sdeleteitem">
                    <div class="col-lg-12">
                      <article class="card mb-2">
                        <center>
                          <div class="col-5">
                            <div class="design-image">
                              <img
                                src="img/dashboard_no_item.jpg"
                                alt="Image"
                                class="card-img-top"
                              />
                            </div>
                            <a @click="cleardata()">
                              <base-button
                                type="primary"
                                size="lg"
                                block
                                class="mb-5 mt-3"
                                icon="fa fa-image"
                                >Clear Search</base-button
                              >
                            </a>
                          </div>
                        </center>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
          <!-- add business -->
          <tab-pane>
            <span slot="title">
              Add Business User
            </span>
            <!-- all business table -->
            <div class="row">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div class="container">
                    <div class="pb-4">
                      <form @submit.prevent>
                        <div class="">
                          <div class="row">
                            <div class="col-md-12 mb-2 mt-2">
                              <label class="form-control-label"
                                >Business Type</label
                              >
                              <select
                                aria-describedby="addon-right addon-left"
                                v-model="model.business_type"
                                class="form-control form-control-alternative"
                                autocomplete="off"
                              >
                                <option value="" disabled=""
                                  >Select type</option
                                >
                                <option value="Designer">Designer</option>
                                <option value="Supplier">Supplier</option>
                                <option value="Designer + Supplier"
                                  >Both</option
                                >
                              </select>
                            </div>
                            <div class="col-lg-12 mt-2">
                              <div
                                v-if="username"
                                class="error h5 text-danger pt-1 pl-1"
                              >
                                Username already exist
                              </div>
                              <div
                                v-if="usernamelength"
                                class="error h5 text-danger pt-1 pl-1"
                              >
                                Username length not less than 4
                              </div>
                              <div
                                v-if="specialcharacter"
                                class="error h5 text-danger pt-1 pl-1"
                              >
                                Only letters, numbers, periods (.) and
                                underscores (_) are allowed — no spaces
                              </div>
                              <base-input
                                alternative=""
                                label="Username"
                                placeholder="Username"
                                input-classes="form-control-alternative"
                                v-model="model.user_name"
                                @change="isValidusername()"
                              />
                              <small class="text-muted d-block mb-2">
                                The username becomes the page URL
                                (nabnee.com/business/username). Only letters,
                                numbers, periods (.) and underscores (_) are
                                allowed — no spaces. Always saved lowercase.
                              </small>
                            </div>
                            <div class="col-lg-12">
                              <div
                                v-if="!emailValid"
                                class="error h5 text-danger pt-1 pl-1"
                              >
                                Email is not valid
                              </div>
                              <base-input
                                alternative=""
                                label="Email"
                                placeholder="Email"
                                input-classes="form-control-alternative"
                                v-model="model.user_email"
                                @change="isValidEmail()"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Create Password"
                                placeholder="Create Password"
                                type="password"
                                input-classes="form-control-alternative"
                                v-model="model.user_password"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Confirm Password"
                                placeholder="Confirm Password"
                                type="password"
                                input-classes="form-control-alternative"
                                v-model="model.cuser_password"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Business Name (English)"
                                placeholder="Business Name (English)"
                                input-classes="form-control-alternative"
                                v-model="model.business_name"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Business Description (English)"
                                placeholder="Business Description (English)"
                                input-classes="form-control-alternative"
                                v-model="model.business_description"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Business Name (Arabic)"
                                placeholder="Business Name (Arabic)"
                                input-classes="form-control-alternative"
                                v-model="model.business_name_ar"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Business Description (Arabic)"
                                placeholder="Business Description (Arabic)"
                                input-classes="form-control-alternative"
                                v-model="model.business_description_ar"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                type="file"
                                alternative=""
                                label="Logo"
                                placeholder="Logo"
                                @change="hadleimage"
                                input-classes="form-control-alternative"
                              />
                              <div v-if="uploadPercentage > 0 && uploadPercentage < 100" class="mt-2">
                                <label class="form-control-label">Upload Progress</label>
                                <progress style="width: 100%; height: 2em;" max="100" :value.prop="uploadPercentage"></progress>
                                <small class="text-muted">{{ uploadPercentage }}%</small>
                              </div>
                            </div>
                            <div
                              class="col-10 col-md-4 card-body offset-md-1 card shadow"
                              v-if="model.logo"
                            >
                              Logo:
                              <img :src="model.logo" class="img-fluid" />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                type="file"
                                alternative=""
                                label="Cover Image"
                                placeholder="Cover Image"
                                @change="hadleicon"
                                input-classes="form-control-alternative"
                              />
                              <div v-if="uploadPercentage > 0 && uploadPercentage < 100" class="mt-2">
                                <label class="form-control-label">Upload Progress</label>
                                <progress style="width: 100%; height: 2em;" max="100" :value.prop="uploadPercentage"></progress>
                                <small class="text-muted">{{ uploadPercentage }}%</small>
                              </div>
                            </div>
                            <div
                              class="col-10 col-md-4 card-body offset-md-1 card shadow"
                              v-if="model.cover_image"
                            >
                              Cover Image:
                              <img :src="model.cover_image" class="img-fluid" />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="No of quotes allowed"
                                placeholder="Business Description (English)"
                                input-classes="form-control-alternative"
                                v-model="model.noofquotes"
                              />
                            </div>

                            <div class="col-md-12 mb-2">
                              <base-input
                                alternative=""
                                label="Max hashtags allowed"
                                placeholder="Maximum number of hashtags a business can add"
                                input-classes="form-control-alternative"
                                v-model="model.max_hashtags"
                              />
                            </div>

                            <div class="col-md-12 mb-2">
                              <label class="form-control-label"
                                >Business Categories & Subcategories</label
                              >
                              <business-category-selector
                                :initial-selected-categories="
                                  model.business_categories
                                "
                                :initial-selected-subcategories="
                                  model.business_subcategories
                                "
                                @update:categories="
                                  model.business_categories = $event
                                "
                                @update:subcategories="
                                  model.business_subcategories = $event
                                "
                                :business-type="model.business_type"
                              />
                            </div>
                            <div class="col-lg-12 mb-2">
                              <label class="form-control-label"
                                >Business GPS Address (Google Map API)</label
                              >
                              <vue-google-autocomplete
                                ref="address"
                                id="map"
                                classname="form-control mb-0"
                                placeholder="Business GPS Address"
                                v-on:placechanged="getAddressData"
                                types="establishment"
                              >
                              </vue-google-autocomplete>
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Business GPS Address (Link)"
                                placeholder="Business GPS Address"
                                input-classes="form-control-alternative"
                                v-model="model.gpslink"
                              />
                              <small
                                v-if="model.location_lat && model.location_long"
                                class="text-success"
                              >
                                <i class="fas fa-check-circle mr-1"></i>
                                Coordinates extracted successfully:
                                {{ model.location_lat }},
                                {{ model.location_long }}
                              </small>
                              <small
                                v-else-if="model.gpslink"
                                class="text-danger"
                              >
                                <i class="fas fa-exclamation-circle mr-1"></i>
                                Could not extract coordinates from URL. Please
                                use a Google Maps URL that contains
                                "@latitude,longitude".
                              </small>
                            </div>
                            <div class="col-md-12 mb-2">
                              <label class="form-control-label">Country</label>
                              <select
                                aria-describedby="addon-right addon-left"
                                v-model="model.user_country"
                                class="form-control form-control-alternative"
                                autocomplete="off"
                              >
                                <option value="" disabled=""
                                  >Select country</option
                                >
                                <option
                                  v-for="country in countrydata"
                                  :key="country._id"
                                  :value="country.country_name"
                                  >{{ country.country_name }}</option
                                >
                              </select>
                            </div>
                            <div class="col-12 mb-2">
                              <label class="form-control-label">City</label>
                              <select
                                aria-describedby="addon-right addon-left"
                                class="form-control form-control-alternative"
                                autocomplete="off"
                                @change="filtercitybusiness()"
                                v-model="model.business_city"
                              >
                                <option value="" disabled=""
                                  >Select city</option
                                >
                                <option
                                  v-for="city in cities"
                                  :value="city.filter_name"
                                  :key="city.filter_name"
                                  >{{
                                    city.filter_name +
                                      '(' +
                                      city.filter_name_ar +
                                      ')'
                                  }}</option
                                >
                              </select>
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Business Address (English)"
                                placeholder="Business Address (English)"
                                input-classes="form-control-alternative"
                                v-model="model.address"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Business Address (Arabic)"
                                placeholder="Business Address (Arabic)"
                                input-classes="form-control-alternative"
                                v-model="model.address_ar"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Phone"
                                placeholder="Phone"
                                input-classes="form-control-alternative"
                                v-model="model.user_phone"
                              />
                            </div>
                            <!-- business hours -->
                            <div class="col-lg-12">
                              <div class="row mb-4 w-100">
                                <div class="col-12">
                                  <div class="d-flex align-items-center mb-3">
                                    <div>
                                      <h4
                                        class="mb-0 font-weight-800 text-dark"
                                      >
                                        Business Hours
                                      </h4>
                                      <p class="text-muted mb-0">
                                        Set your business operating hours for
                                        customers
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div
                                class="card shadow border-0 mb-5"
                                style="border-radius: 12px;"
                              >
                                <div class="card-header bg-white border-0 py-4">
                                  <div
                                    class="d-flex justify-content-between align-items-center"
                                  >
                                    <div>
                                      <h5
                                        class="mb-1 font-weight-bold text-dark"
                                      >
                                        Set Operating Hours
                                      </h5>
                                      <p class="mb-0 text-muted small">
                                        Configure when your business is open
                                      </p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                      <span class="text-muted small mr-3"
                                        >Apply to all days</span
                                      >
                                      <div class="custom-control custom-switch">
                                        <input
                                          type="checkbox"
                                          class="custom-control-input"
                                          id="sameas"
                                          v-model="checkvalue"
                                          @click="sameastime()"
                                        />
                                        <label
                                          class="custom-control-label"
                                          for="sameas"
                                        ></label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-body p-4">
                                  <div class="hours-container">
                                    <div
                                      class="hour-row"
                                      v-for="(day, index) in business_hours"
                                      :key="index"
                                    >
                                      <div
                                        class="d-flex align-items-center justify-content-between py-3 px-3 rounded-lg mb-2 google-hour-row"
                                        :class="{
                                          'closed-day-row': day.closed,
                                        }"
                                      >
                                        <div class="day-name">
                                          <span
                                            class="font-weight-600"
                                            :class="
                                              day.closed
                                                ? 'text-muted'
                                                : 'text-dark'
                                            "
                                          >
                                            {{
                                              {
                                                Sun: 'Sunday',
                                                Mon: 'Monday',
                                                Tue: 'Tuesday',
                                                Wed: 'Wednesday',
                                                Thu: 'Thursday',
                                                Fri: 'Friday',
                                                Sat: 'Saturday',
                                              }[day.day]
                                            }}
                                          </span>
                                        </div>

                                        <div
                                          class="time-controls d-flex align-items-center"
                                          v-if="!day.closed"
                                        >
                                          <div class="time-input-group mr-3">
                                            <vue-timepicker
                                              v-model="day.from"
                                              format="hh:mm A"
                                              placeholder="8:00 AM"
                                              @change="
                                                checktime(
                                                  day.from,
                                                  day.to,
                                                  'add'
                                                )
                                              "
                                              class="google-time-picker"
                                              :input-class="
                                                'form-control text-center google-time-input'
                                              "
                                            ></vue-timepicker>
                                          </div>
                                          <span
                                            class="text-muted mx-2 font-weight-500"
                                            >–</span
                                          >
                                          <div class="time-input-group mr-3">
                                            <vue-timepicker
                                              v-model="day.to"
                                              format="hh:mm A"
                                              placeholder="11:00 PM"
                                              @change="
                                                sameastime();
                                                checktime(
                                                  day.from,
                                                  day.to,
                                                  'add'
                                                );
                                              "
                                              class="google-time-picker"
                                              :input-class="
                                                'form-control text-center google-time-input'
                                              "
                                            ></vue-timepicker>
                                          </div>
                                        </div>

                                        <div
                                          class="closed-status d-flex align-items-center"
                                          v-if="day.closed"
                                        >
                                          <span
                                            class="text-danger font-weight-600 closed-text"
                                          >
                                            <i
                                              class="fas fa-times-circle mr-2"
                                            ></i
                                            >Closed
                                          </span>
                                        </div>

                                        <div class="closed-toggle">
                                          <div
                                            class="custom-control custom-checkbox"
                                          >
                                            <input
                                              type="checkbox"
                                              class="custom-control-input"
                                              :id="'closed-business-' + index"
                                              v-model="day.closed"
                                              @change="toggleBusinessDay(index)"
                                            />
                                            <label
                                              class="custom-control-label text-muted small cursor-pointer"
                                              :for="'closed-business-' + index"
                                            >
                                              Closed
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Error Alert -->
                                  <div
                                    id="timev"
                                    class="alert alert-danger border-0 mt-3"
                                    style="display: none; border-radius: 8px;"
                                  >
                                    <div class="d-flex align-items-center">
                                      <i
                                        class="fas fa-exclamation-triangle text-danger mr-2"
                                      ></i>
                                      <span class="small"
                                        >Please check your opening and closing
                                        times.</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12 d-flex mt-2">
                              <div class="row mb-4 w-100">
                                <div class="col-12">
                                  <div class="d-flex align-items-center mb-3">
                                    <div>
                                      <h4
                                        class="mb-0 font-weight-800 text-dark"
                                      >
                                        Leisure & Break Hours
                                      </h4>
                                      <p class="text-muted mb-0">
                                        Set up break times and leisure hours for
                                        your business
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div
                                class="card shadow border-0 mb-5"
                                style="border-radius: 12px;"
                              >
                                <div class="card-header bg-white border-0 py-4">
                                  <div
                                    class="d-flex justify-content-between align-items-center"
                                  >
                                    <div>
                                      <h5
                                        class="mb-1 font-weight-bold text-dark"
                                      >
                                        Break Hours
                                      </h5>
                                      <p class="mb-0 text-muted small">
                                        Set your business break times
                                      </p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                      <span class="text-muted small mr-3"
                                        >Apply to all days</span
                                      >
                                      <div class="custom-control custom-switch">
                                        <input
                                          type="checkbox"
                                          class="custom-control-input"
                                          id="lsameas"
                                          v-model="lcheckvalue"
                                          @click="lsameastime()"
                                        />
                                        <label
                                          class="custom-control-label"
                                          for="lsameas"
                                        ></label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-body p-4">
                                  <div class="hours-container">
                                    <div
                                      class="hour-row"
                                      v-for="(day, index) in leisure_hours"
                                      :key="index"
                                    >
                                      <div
                                        class="d-flex align-items-center justify-content-between py-3 px-3 rounded-lg mb-2 google-hour-row"
                                        :class="{
                                          'closed-day-row': day.closed,
                                        }"
                                      >
                                        <div class="day-name">
                                          <span
                                            class="font-weight-600"
                                            :class="
                                              day.closed
                                                ? 'text-muted'
                                                : 'text-dark'
                                            "
                                          >
                                            {{
                                              {
                                                Sun: 'Sunday',
                                                Mon: 'Monday',
                                                Tue: 'Tuesday',
                                                Wed: 'Wednesday',
                                                Thu: 'Thursday',
                                                Fri: 'Friday',
                                                Sat: 'Saturday',
                                              }[day.day]
                                            }}
                                          </span>
                                        </div>

                                        <div
                                          class="time-controls d-flex align-items-center"
                                          v-if="!day.closed"
                                        >
                                          <div class="time-input-group mr-3">
                                            <vue-timepicker
                                              v-model="day.from"
                                              format="hh:mm A"
                                              placeholder="1:00 PM"
                                              @change="
                                                lchecktime(
                                                  day.from,
                                                  day.to,
                                                  'add'
                                                )
                                              "
                                              class="google-time-picker"
                                              :input-class="
                                                'form-control text-center google-time-input'
                                              "
                                            ></vue-timepicker>
                                          </div>
                                          <span
                                            class="text-muted mx-2 font-weight-500"
                                            >–</span
                                          >
                                          <div class="time-input-group mr-3">
                                            <vue-timepicker
                                              v-model="day.to"
                                              format="hh:mm A"
                                              placeholder="2:00 PM"
                                              @change="
                                                lsameastime();
                                                lchecktime(
                                                  day.from,
                                                  day.to,
                                                  'add'
                                                );
                                              "
                                              class="google-time-picker"
                                              :input-class="
                                                'form-control text-center google-time-input'
                                              "
                                            ></vue-timepicker>
                                          </div>
                                        </div>

                                        <div
                                          class="closed-status d-flex align-items-center"
                                          v-if="day.closed"
                                        >
                                          <span
                                            class="text-muted font-weight-600 closed-text"
                                          >
                                            <i class="fas fa-coffee mr-2"></i>No
                                            break
                                          </span>
                                        </div>

                                        <div class="closed-toggle">
                                          <div
                                            class="custom-control custom-checkbox"
                                          >
                                            <input
                                              type="checkbox"
                                              class="custom-control-input"
                                              :id="'closed-leisure-' + index"
                                              v-model="day.closed"
                                              @change="toggleLeisureDay(index)"
                                            />
                                            <label
                                              class="custom-control-label text-muted small cursor-pointer"
                                              :for="'closed-leisure-' + index"
                                            >
                                              No break
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Error Alert -->
                                  <div
                                    id="ltimev"
                                    class="alert alert-danger border-0 mt-3"
                                    style="display: none; border-radius: 8px;"
                                  >
                                    <div class="d-flex align-items-center">
                                      <i
                                        class="fas fa-exclamation-triangle text-danger mr-2"
                                      ></i>
                                      <span class="small"
                                        >Please check your break start and end
                                        times.</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <hr />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Website"
                                placeholder="Website"
                                input-classes="form-control-alternative"
                                v-model="model.user_website"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Facebook Link"
                                placeholder="username only"
                                input-classes="form-control-alternative"
                                v-model="model.cuser_facebook"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Instagram Link"
                                placeholder="username only"
                                input-classes="form-control-alternative"
                                v-model="model.user_instagram"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="YouTube Link"
                                placeholder="channel_id"
                                input-classes="form-control-alternative"
                                v-model="model.user_youtube"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="X (Twitter) Link"
                                placeholder="twitter handle only"
                                input-classes="form-control-alternative"
                                v-model="model.user_twitter"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="WhatsApp Number"
                                placeholder="e.g. +968 9999 9999"
                                input-classes="form-control-alternative"
                                v-model="model.user_whatsapp"
                              />
                            </div>

                            <div class="col-lg-12 mt-2 mb-4">
                              <label class="form-control-label"
                                >Email language</label
                              >
                              <select
                                aria-describedby="addon-right addon-left"
                                class="form-control form-control-alternative"
                                autocomplete="off"
                                v-model="language"
                              >
                                <option value="newbusinessuserprofile"
                                  >English</option
                                >
                                <option value="newbusinessuserprofile_ar"
                                  >Arabic</option
                                >
                              </select>
                            </div>

                            <div class="col-lg-12">
                              <base-button
                                :disabled="
                                  usernamelength || username || specialcharacter
                                "
                                type="primary"
                                id="saveuserbtn"
                                @click="saveuser()"
                                >Create Profile</base-button
                              >
                            </div>
                            <div
                              class="col-lg-12 mt-3"
                              v-if="addClaimLink || addClaimLinkError"
                            >
                              <label
                                class="form-control-label"
                                v-if="addClaimLink"
                                >Claim link for {{ addClaimEmail }}</label
                              >
                              <div v-if="addClaimLink" class="input-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  :value="addClaimLink"
                                  readonly
                                  ref="addClaimLinkInput"
                                  @focus="$event.target.select()"
                                />
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-outline-primary"
                                    type="button"
                                    @click="copyAddClaimLink"
                                  >
                                    {{ addClaimCopied ? 'Copied!' : 'Copy' }}
                                  </button>
                                </div>
                              </div>
                              <small
                                v-if="addClaimLink"
                                class="text-muted d-block"
                              >
                                Valid for 7 days — copy it and send it to the
                                business directly (e.g. via WhatsApp).
                              </small>
                              <div
                                v-if="addClaimLinkError"
                                class="text-danger small"
                              >
                                {{ addClaimLinkError }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
          <!-- Bulk add  -->
          <tab-pane>
            <span slot="title">
              Add Bulk Business Users
            </span>
            <!-- all business table -->
            <div class="row">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div class="container">
                    <div class="pb-4">
                      <form @submit.prevent>
                        <div class="row">
                          <div class="col-lg-12 mt-2">
                            <div
                              v-if="noBulkJSONfile"
                              class="error h5 text-danger pt-1 pl-1"
                            >
                              Upload JSON file
                            </div>
                            <base-input
                              type="file"
                              label="JSON file"
                              input-classes="form-control-alternative"
                              @change="bulkJSONfileHandling"
                            />
                          </div>
                          <div
                            class="col-lg-12 mt-2 d-flex justify-content-center align-items-center"
                          >
                            <base-button
                              type="primary"
                              size="md"
                              @click="createBulkUsers"
                              icon="fa fa-checkmark"
                              >Create</base-button
                            >
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
        </div>
      </tabs>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VueSwal, { swal } from 'vue-swal';
import moment from 'moment';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import BusinessCategorySelector from '@/components/BusinessCategorySelector.vue';
import { compressImageIfNeeded } from '../utils/imageCompression';
export default {
  name: 'tables',
  components: {
    VueTimepicker,
    VueGoogleAutocomplete,
    BusinessCategorySelector,
  },
  props: {
    initialSelectedCategories: Array,
    initialSelectedSubcategories: Array,
    businessType: String,
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      noBulkJSONfile: false,
      bulkJSONfile: null,
      search: '',
      selected: false,
      address: '',
      language: 'newbusinessuserprofile',
      checkvalue: false,
      emailValid: true,
      username: false,
      usernamelength: false,
      specialcharacter: false,
      addClaimLink: '',
      addClaimEmail: '',
      addClaimLinkError: '',
      addClaimCopied: false,
      lcheckvalue: false,
      searchData: [],
      categories: [],
      shouldShowCategorySelect: true,
      categorySelectKey: 0,
      subcategories: [],
      cities: [],
      countrydata: [],
      businessData: [],
      reportedcaption: [],
      business_hours: [
        {
          day: 'Sun',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Mon',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Tue',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Wed',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Thu',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Fri',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Sat',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
      ],
      leisure_hours: [
        {
          day: 'Sun',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Mon',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Tue',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Wed',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Thu',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Fri',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Sat',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
      ],
      offset: 0,
      u_offset: 0,
      deleteitem: false,
      sdeleteitem: false,
      r_offset: 0,
      modals: {
        editbusiness: false,
        stats: false,
        business_name: '',
        business_name_ar: '',
        business_description_ar: '',
        business_description: '',
        business_type: 'business',
        business_visibility: 'Public',
        business_category: '',
        business_subcategory: '',
        selected_categories: [],
        selected_subcategories: [],
        filter_business_type: '',
        business_space: '',
        business_city: '',
        business_cost: '',
        business_theme_color: '',
        business_tags: '',
        optype: 'Add',
        business_img: '',
        business_mentions: '',
        business_rate: '',
        created_by: '',
        status: '',
      },

      model: {
        item_name: '',
        item_name_ar: '',
        item_description_ar: '',
        item_description: '',
        item_type: 'business',
        user_status: '',
        item_visibility: 'Public',
        item_category: '',
        item_subcategory: '',
        item_space: '',
        item_brand: '',
        item_cost: '',
        item_theme_color: '',
        item_tags: '',
        optype: 'Add',
        item_img: '',
        item_mentions: '',
        item_rate: '',
        created_by: '',
        status: '',
        user_email: '',
        user_password: '',
        cuser_password: '',
        user_name: '',
        user_businessname: '',
        user_country: localStorage.getItem('country_name'),
        user_businessdescription: '',
        user_businessemail: '',
        user_businessnamearabic: '',
        user_businessdescriptionarabic: '',
        business_category: [],
        business_subcategory: [],
        user_businessaddressenglish: '',
        user_businessaddressarabic: '',
        business_city: '',
        business_type: '',
        user_phone: '',
        user_website: '',
        cuser_facebook: '',
        user_instagram: '',
        user_youtube: '',
        user_twitter: '',
        user_whatsapp: '',
        logo: '',
        cover_image: '',
        gpslink: '',
      },
      status: {
        0: { val: 'approved' },
        1: { val: 'rejected' },
        2: { val: 'pending' },
        3: { val: 'suspended' },
      },
      auth: {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        },
      },
      auth1: {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        },
      },
    };
  },

  computed: {
    filteredCategories() {
      const type = this.modals.filter_business_type;

      if (!type || type === '') {
        // No filter selected - show all categories
        return this.categories;
      }

      if (type === 'Designer') {
        // Designer - show only "Architectural & Engineering Consultancy"
        return this.categories.filter(
          (item) =>
            item.business_category_name ===
            'Architectural & Engineering Consultancy'
        );
      } else if (type === 'Supplier') {
        // Supplier - show all except "Architectural & Engineering Consultancy"
        return this.categories.filter(
          (item) =>
            item.business_category_name !==
            'Architectural & Engineering Consultancy'
        );
      } else if (type === 'Designer + Supplier') {
        // Both - show all categories (no filter)
        return this.categories;
      }

      return this.categories;
    },
  },

  mounted() {
    this.getCategoriesByType(this.model.business_type);
    this.path = process.env.VUE_APP_API_ENDPOINT;
    const querystring = require('querystring');
    console.log(this.auth);
    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
        details: { user_type: 'Business' },
        offset: '0',
      })
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.businessData = response.data.details;
        }
      });
    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_country', {
        details: { status: 'approved' },
        offset: '0',
      })
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.countrydata = response.data.details;
        }
      });

    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_category', {
        status: 'approved',
      })
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.categories = response.data.details;
        }
      });

    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_filter_all', {
        filters: { filter_name: 'city' },
      })
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.cities = response.data.details;
        }
      });
  },

  watch: {
    'model.gpslink': function(newVal) {
      this.extractCoordinatesFromMapUrl();
    },
    'model.business_type'(newType, oldType) {
      console.log('Business type changed:', oldType, '->', newType);

      // Reset everything
      this.modals.business_category = '';
      this.model.business_category = '';
      this.model.business_categories = [];
      this.model.business_subcategory = '';
      this.model.business_subcategories = [];

      // Force complete re-render of select
      this.shouldShowCategorySelect = false;
      this.$nextTick(() => {
        this.shouldShowCategorySelect = true;
        this.categorySelectKey++; // Force new key
        this.getCategoriesByType(newType);
      });
    },
  },

  methods: {
    onFilterBusinessTypeChange() {
      // Reset category and subcategory when business type filter changes
      this.modals.business_category = '';
      this.modals.business_subcategory = '';
      this.modals.selected_categories = [];
      this.modals.selected_subcategories = [];
      this.subcategories = [];

      // Force category select to re-render
      this.categorySelectKey++;
    },

    getAddressData: function(addressData, placeResultData, id) {
      this.address = addressData;
      let place = document.getElementById('map').value;
      console.log('Address data from Google Places:', this.address);

      // Extract and store latitude and longitude
      if (addressData && addressData.latitude && addressData.longitude) {
        this.model.location_lat = addressData.latitude;
        this.model.location_long = addressData.longitude;
        console.log(
          'Coordinates from Google Places:',
          this.model.location_lat,
          this.model.location_long
        );

        // Generate a Google Maps link for the location
        this.model.gpslink = `https://www.google.com/maps/place/${encodeURIComponent(
          place
        )}/@${addressData.latitude},${addressData.longitude},17z`;
      }

      this.model.user_businessaddressenglish = place;
      this.model.user_country = this.address.country || this.model.user_country;
      this.model.address = place;
    },
    hadleimage: async function(event) {
      // Reference to the DOM input element
      this.uploadPercentage = 0;
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB limit
      if (input.files[0].size < MAX_FILE_SIZE) {
        // Compress image if it's larger than 2MB
        const compressedFile = await compressImageIfNeeded(input.files[0]);
        
        const fd = new FormData();
        fd.append('image', compressedFile, compressedFile.name);

        // Add authentication headers for file upload
        const uploadHeaders = {
          'Content-Type': 'multipart/form-data',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        };

        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'image-upload', fd, {
            headers: uploadHeaders,
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
              console.log('Logo upload progress:', this.uploadPercentage + '%');
            }.bind(this),
          })
          .then((response) => {
            this.model.logo = response.data.imageUrl;

            // Reset upload percentage after successful upload
            setTimeout(() => {
              this.uploadPercentage = 0;
            }, 1000);
          })
          .catch((error) => {
            console.error('Logo upload error:', error);

            // Reset upload percentage on error
            this.uploadPercentage = 0;

            // Show user-friendly error message
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              swal({
                title: 'Upload Failed',
                text: error.response.data.message,
                icon: 'error',
              });
            } else {
              swal({
                title: 'Upload Failed',
                text: 'Logo upload failed. Please try again.',
                icon: 'error',
              });
            }
          });
      } else {
        swal({
          title: 'File too large!',
          text:
            'Your file is larger than 50 MB. Please upload images which are less than 50 MB.',
          icon: 'warning',
        }).then((result) => {});
      }
    },
    hadleicon: function(event) {
      // Reference to the DOM input element
      this.uploadPercentage = 0;
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB limit
      if (input.files[0].size < MAX_FILE_SIZE) {
        const fd = new FormData();
        fd.append('image', input.files[0], input.files[0].name);

        // Add authentication headers for file upload
        const uploadHeaders = {
          'Content-Type': 'multipart/form-data',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        };

        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'image-upload', fd, {
            headers: uploadHeaders,
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
              console.log(
                'Cover image upload progress:',
                this.uploadPercentage + '%'
              );
            }.bind(this),
          })
          .then((response) => {
            console.log('Cover image upload response:', response);
            this.model.cover_image = response.data.imageUrl;

            // Reset upload percentage after successful upload
            setTimeout(() => {
              this.uploadPercentage = 0;
            }, 1000);
          })
          .catch((error) => {
            console.error('Cover image upload error:', error);

            // Reset upload percentage on error
            this.uploadPercentage = 0;

            // Show user-friendly error message
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              swal({
                title: 'Upload Failed',
                text: error.response.data.message,
                icon: 'error',
              });
            } else {
              swal({
                title: 'Upload Failed',
                text: 'Cover image upload failed. Please try again.',
                icon: 'error',
              });
            }
          });
      } else {
        swal({
          title: 'File to large!',
          text:
            'Your file is larger than 5 MB. Please upload images which are less than 5 MB.',
          icon: 'warning',
        }).then((result) => {});
      }
    },
    bulkJSONfileHandling: function(event) {
      this.bulkJSONfile = event.target.files[0];
      this.noBulkJSONfile = false;
    },
    createBulkUsers: function() {
      if (!this.bulkJSONfile) {
        this.noBulkJSONfile = true;
        return;
      }

      if (this.bulkJSONfile.type !== 'application/json') {
        swal({
          title: 'Error!',
          text: 'The file is not in JSON format',
          icon: 'warning',
        });
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        let content;
        try {
          content = JSON.parse(reader.result);
        } catch (error) {
          swal({
            title: 'Error!',
            text: `Couldn't read file ${error}`,
            icon: 'warning',
          });
          return;
        }
        if (!content) {
          swal({
            title: 'Error!',
            text: 'No content was read',
            icon: 'warning',
          });
          return;
        }
        // console.log("Bulk: ", content);
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'create_bulk_users', {
            usersData: content,
          })
          .then((response) => {
            console.log('Bulk Upload: ', response);
            if ((response.data.success = true)) {
              swal({
                title: 'Success',
                text: 'Users Created Successfully',
                icon: 'success',
              });
            } else {
              swal({
                title: 'Error!',
                text: `There was a problem ${response.data.message}`,
                icon: 'warning',
              });
            }
          });
      };
      reader.readAsText(this.bulkJSONfile);
    },
    checktime(start_time, end_time, type) {
      let start_time1 =
        start_time.hh + ':' + start_time.mm + ' ' + start_time.A;
      let end_time1 = end_time.hh + ':' + end_time.mm + ' ' + end_time.A;
      var startTime = moment(start_time1, 'HH:mm a');
      var endTime = moment(end_time1, 'HH:mm a');
      if (endTime.hour() < startTime.hour()) {
        console.log("Batch start time can't be greater than batch end time");
        if (type == 'edit') {
          document.getElementById('edittimev').innerHTML =
            "Batch start time can't be greater than batch end time";
        } else {
          document.getElementById('timev').innerHTML =
            "Batch start time can't be greater than batch end time";
        }
      } else if (
        endTime.hour() == startTime.hour() &&
        endTime.minute() <= startTime.minute()
      ) {
        console.log(
          "Batch start time can't be equal or greater than batch end time"
        );
        if (type == 'edit') {
          document.getElementById('edittimev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        } else {
          document.getElementById('timev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        }
      } else {
        if (type == 'edit') {
          document.getElementById('edittimev').innerHTML = '';
        } else {
          document.getElementById('timev').innerHTML = '';
        }
      }
      return false;
    },
    sameastime() {
      const inputElements = document.getElementById('sameas');
      if (!inputElements || !inputElements.checked) return;

      // Find first day with valid times to copy from
      const src = this.business_hours.find(
        (d) => d && d.from && d.from.hh && d.to && d.to.hh
      );
      if (!src) return;
      const start_time = JSON.parse(JSON.stringify(src.from));
      const end_time = JSON.parse(JSON.stringify(src.to));

      for (let i = 0; i < this.business_hours.length; i++) {
        if (this.business_hours[i].closed) continue;
        this.business_hours[i].from = JSON.parse(JSON.stringify(start_time));
        this.business_hours[i].to = JSON.parse(JSON.stringify(end_time));
      }
    },
    selectday(value) {
      const index = this.days.map((e) => e.day).indexOf(value);
      // console.log(index);
      if (index == -1) {
        document.getElementById(value).classList.add('active');
        this.days.push({
          day: value,
          start_time: { hh: '', mm: '', A: '' },
          end_time: { hh: '', mm: '', A: '' },
        });
        // console.log(this.days);
      } else {
        this.days.splice(index, 1);
        document.getElementById(value).classList.remove('active');
        // console.log(this.days);
      }
    },
    removeday(index) {
      document.getElementById(this.days[index].day).classList.remove('active');
      this.days.splice(index, 1);
      // console.log(this.days);
    },
    lchecktime(start_time, end_time, type) {
      let start_time1 =
        start_time.hh + ':' + start_time.mm + ' ' + start_time.A;
      let end_time1 = end_time.hh + ':' + end_time.mm + ' ' + end_time.A;
      var startTime = moment(start_time1, 'HH:mm a');
      var endTime = moment(end_time1, 'HH:mm a');
      if (endTime.hour() < startTime.hour()) {
        console.log("Batch start time can't be greater than batch end time");
        if (type == 'edit') {
          document.getElementById('ledittimev').innerHTML =
            "Batch start time can't be greater than batch end time";
        } else {
          document.getElementById('ltimev').innerHTML =
            "Batch start time can't be greater than batch end time";
        }
      } else if (
        endTime.hour() == startTime.hour() &&
        endTime.minute() <= startTime.minute()
      ) {
        if (type == 'edit') {
          document.getElementById('ledittimev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        } else {
          document.getElementById('ltimev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        }
      } else {
        if (type == 'edit') {
          document.getElementById('ledittimev').innerHTML = '';
        } else {
          document.getElementById('ltimev').innerHTML = '';
        }
      }
      return false;
    },
    lsameastime() {
      const inputElements = document.getElementById('lsameas');
      if (!inputElements || !inputElements.checked) return;

      // Find first day with valid times to copy from
      const src = this.leisure_hours.find(
        (d) => d && d.from && d.from.hh && d.to && d.to.hh
      );
      if (!src) return;
      const start_time = JSON.parse(JSON.stringify(src.from));
      const end_time = JSON.parse(JSON.stringify(src.to));

      for (let i = 0; i < this.leisure_hours.length; i++) {
        if (this.leisure_hours[i].closed) continue;
        this.leisure_hours[i].from = JSON.parse(JSON.stringify(start_time));
        this.leisure_hours[i].to = JSON.parse(JSON.stringify(end_time));
      }
    },
    lselectday(value) {
      const index = this.ldays.map((e) => e.day).indexOf(value);
      // console.log(index);
      if (index == -1) {
        document.getElementById(value).classList.add('active');
        this.ldays.push({
          day: value,
          start_time: { hh: '', mm: '', A: '' },
          end_time: { hh: '', mm: '', A: '' },
        });
        // console.log(this.days);
      } else {
        this.ldays.splice(index, 1);
        document.getElementById(value).classList.remove('active');
        // console.log(this.days);
      }
    },
    lremoveday(index) {
      document.getElementById(this.ldays[index].day).classList.remove('active');
      this.ldays.splice(index, 1);
      // console.log(this.days);
    },
    toggleBusinessDay(index) {
      if (this.business_hours[index].closed) {
        this.business_hours[index].from = { hh: '', mm: '', A: 'AM' };
        this.business_hours[index].to = { hh: '', mm: '', A: 'AM' };
      }
    },
    toggleLeisureDay(index) {
      if (this.leisure_hours[index].closed) {
        this.leisure_hours[index].from = { hh: '', mm: '', A: 'AM' };
        this.leisure_hours[index].to = { hh: '', mm: '', A: 'AM' };
      }
    },
    deletebusiness(row) {
      const querystring = require('querystring');
      swal({
        title: 'Delete this item?',
        text: 'This action is not reversible.',
        icon: 'warning',
        buttons: { cancel: true, confirm: true },
      }).then((result) => {
        // <--
        if (result) {
          console.log('result cloud', result);
          axios
            .post(
              process.env.VUE_APP_API_ENDPOINT + 'delete_business',
              querystring.stringify({
                user_email: row.user_email,
                _id: row._id,
              }),
              this.auth1
            )
            .then((response) => {
              console.log(response);
              if (response.data && response.data.success) {
                swal({
                  title: 'Deleted!',
                  text: 'Your file has been deleted.',
                  icon: 'success',
                }).then((result) => {
                  console.log(result);
                  window.location.reload();
                });
              } else {
                swal({
                  title: 'Not deleted',
                  text:
                    (response.data && response.data.message) ||
                    'This business could not be deleted. Please try again.',
                  icon: 'error',
                });
              }
            })
            .catch((error) => {
              console.log(error);
              swal({
                title: 'Not deleted',
                text: 'This business could not be deleted. Please try again.',
                icon: 'error',
              });
            });
        }
      });
    },
    checkFromBeforeSubmit() {
      console.log(
        'testing ',
        this.model.user_name,
        this.model.user_name.length
      );
      let errormessage = '';
      this.model.user_name.length == 0
        ? (errormessage = 'Please enter a username')
        : null;
      this.model.user_password.length == 0
        ? (errormessage = 'Please enter a password')
        : null;
      this.model.user_email.length == 0
        ? (errormessage = 'Please enter an email')
        : null;
      this.emailValid ? null : (errormessage = 'Please enter a valid email');
      this.username ? (errormessage = 'Username already exist') : null;
      this.usernamelength
        ? (errormessage = 'Username length not less than 4')
        : null;
      this.specialcharacter
        ? (errormessage = 'Special character not allowed')
        : null;
      if (errormessage.length == 0) {
        return false;
      } else {
        return errormessage;
      }
    },

    extractCoordinatesFromMapUrl() {
      const url = this.model.gpslink;
      if (!url) {
        this.model.location_lat = '';
        this.model.location_long = '';
        return;
      }

      try {
        // Handle full Google Maps URLs
        if (url.includes('google.com/maps')) {
          // Extract coordinates from URL like https://www.google.com/maps/place/.../@8.9961731,38.7498291,16z/...
          const matches = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
          if (matches && matches.length >= 3) {
            this.model.location_lat = matches[1];
            this.model.location_long = matches[2];
            return;
          }
        }
        // Handle short URLs (maps.app.goo.gl)
        else if (url.includes('maps.app.goo.gl')) {
          // These URLs don't contain coordinates directly
          // Show warning to user that they need to use the full URL
          swal({
            title: 'URL Format',
            text:
              'Please use the full Google Maps URL that contains coordinates (@lat,lng)',
            icon: 'warning',
          });
        }

        this.model.location_lat = '';
        this.model.location_long = '';
      } catch (error) {
        console.error('Error extracting coordinates:', error);
        this.model.location_lat = '';
        this.model.location_long = '';
      }
    },
    saveuser() {
      document.getElementById('saveuserbtn').innerHTML = 'Loading...';

      // Check form data before submission
      let errorMsg = this.checkFromBeforeSubmit();
      if (errorMsg != false) {
        swal({
          title: 'Error',
          text: errorMsg,
          icon: 'warning',
        }).then((result) => {});
        document.getElementById('saveuserbtn').innerHTML = 'Create Profile';
        return;
      }

      // Check if passwords match
      if (this.model.user_password !== this.model.cuser_password) {
        swal({
          title: 'Error',
          text: 'Password and confirm password do not match',
          icon: 'warning',
        });
        document.getElementById('saveuserbtn').innerHTML = 'Create Profile';
        return;
      }

      if (
        this.model.gpslink &&
        (!this.model.location_lat || !this.model.location_long)
      ) {
        this.extractCoordinatesFromMapUrl();

        if (!this.model.location_lat || !this.model.location_long) {
          swal({
            title: 'Location Error',
            text:
              'Could not extract coordinates from the provided GPS link. Please use a Google Maps URL that contains coordinates.',
            icon: 'warning',
          });
          document.getElementById('saveuserbtn').innerHTML = 'Create Profile';
          return;
        }
      }
      const querystring = require('querystring');
      console.log('Creating business user:', {
        email: this.model.user_email,
        name: this.model.user_name,
        location_lat: this.model.location_lat,
        location_long: this.model.location_long,
      });

      // Format business hours and leisure hours
      let business_hours = JSON.parse(JSON.stringify(this.business_hours));
      let leisure_hours = JSON.parse(JSON.stringify(this.leisure_hours));

      console.log('Preparing business hours data for registration');

      // Filter out closed days and format the hours properly
      business_hours = business_hours.filter((day) => !day.closed);
      leisure_hours = leisure_hours.filter((day) => !day.closed);

      // Format the hours properly
      for (let i = 0; i < business_hours.length; i++) {
        if (business_hours[i].from && business_hours[i].from.hh) {
          business_hours[i].from =
            business_hours[i].from.hh +
            ':' +
            business_hours[i].from.mm +
            ' ' +
            business_hours[i].from.A;
        }

        if (business_hours[i].to && business_hours[i].to.hh) {
          business_hours[i].to =
            business_hours[i].to.hh +
            ':' +
            business_hours[i].to.mm +
            ' ' +
            business_hours[i].to.A;
        }
      }

      for (let i = 0; i < leisure_hours.length; i++) {
        if (leisure_hours[i].from && leisure_hours[i].from.hh) {
          leisure_hours[i].from =
            leisure_hours[i].from.hh +
            ':' +
            leisure_hours[i].from.mm +
            ' ' +
            leisure_hours[i].from.A;
        }

        if (leisure_hours[i].to && leisure_hours[i].to.hh) {
          leisure_hours[i].to =
            leisure_hours[i].to.hh +
            ':' +
            leisure_hours[i].to.mm +
            ' ' +
            leisure_hours[i].to.A;
        }
      }

      // Register the business user
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'register_business',
          {
            user_email: this.model.user_email,
            user_password: this.model.user_password,
            user_type: 'Business',
            user_public_name: this.model.user_name,
            user_name: this.model.user_name,
            send_email: true,
            language: this.language,
            noofquotes: this.model.noofquotes || 5,
            max_hashtags: this.model.max_hashtags || 5,
            business_hours: business_hours,
            leisure_hours: leisure_hours,
            logo: this.model.logo,
            cover_image: this.model.cover_image,
            business_name: this.model.business_name,
            business_name_english: this.model.business_name,
            business_name_ar: this.model.business_name_ar,
            business_description: this.model.business_description,
            business_description_ar: this.model.business_description_ar,
            business_email: this.model.user_businessemail || '',
            business_phone: this.model.user_phone,
            business_website: this.model.user_website,
            business_address: this.model.address,
            business_address_ar: this.model.address_ar,
            business_city: this.model.business_city,
            business_category: this.model.business_categories,
            business_subcategories: this.model.business_subcategories,
            business_type: this.model.business_type,
            user_phone: this.model.user_phone,
            user_country: this.model.user_country,
            fb_link: this.model.cuser_facebook,
            instagram_link: this.model.user_instagram,
            youtube_link: this.model.user_youtube,
            twitter_link: this.model.user_twitter,
            whatsapp_number: this.model.user_whatsapp,
            web_link: this.model.user_website,
            address: this.model.address,
            address_ar: this.model.address_ar,
            location_lat: this.model.location_lat,
            location_long: this.model.location_long,
            user_status: 'approved',
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: this.auth1.headers.Authorization,
            },
          }
        )
        .then((response) => {
          console.log('User created with all data:', response.data);

          // Show success message
          swal({
            title: 'Success',
            text: this.selected
              ? 'Business created and welcome email sent successfully!'
              : 'Business created successfully!',
            icon: 'success',
          });

          // Fetch a claim link for the new business so the admin can send
          // it directly (e.g. WhatsApp) without opening the edit page.
          const createdEmail = this.model.user_email;
          this.addClaimLink = '';
          this.addClaimLinkError = '';
          this.addClaimCopied = false;
          axios
            .post(
              process.env.VUE_APP_API_ENDPOINT + 'generate_business_claim_link',
              { user_email: createdEmail },
              this.auth
            )
            .then((res2) => {
              if (res2.data && res2.data.success) {
                this.addClaimLink = res2.data.claim_link;
                this.addClaimEmail = createdEmail;
              } else {
                this.addClaimLinkError =
                  (res2.data && res2.data.message) ||
                  'Could not create the claim link.';
              }
            })
            .catch(() => {
              this.addClaimLinkError = 'Could not create the claim link.';
            });

          // Update button style
          document
            .getElementById('saveuserbtn')
            .classList.remove('btn-primary');
          document.getElementById('saveuserbtn').classList.add('btn-success');
          document.getElementById('saveuserbtn').innerHTML = 'Saved';

          // Reset form and refresh data without hard reload
          setTimeout(() => {
            // Reset button style
            document
              .getElementById('saveuserbtn')
              .classList.remove('btn-success');
            document.getElementById('saveuserbtn').classList.add('btn-primary');
            document.getElementById('saveuserbtn').innerHTML = 'Create Profile';

            // Reset form data
            this.resetForm();

            // Refresh business list
            this.refreshBusinessList();
          }, 2000);
        })
        .catch((error) => {
          console.error('Error creating user:', error);

          swal({
            title: 'Error',
            text: 'Failed to create business user',
            icon: 'error',
          });

          document.getElementById('saveuserbtn').innerHTML = 'Create Profile';
        });
    },
    copyAddClaimLink() {
      const markCopied = () => {
        this.addClaimCopied = true;
        setTimeout(() => {
          this.addClaimCopied = false;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.addClaimLink).then(markCopied);
      } else {
        const input = this.$refs.addClaimLinkInput;
        input.select();
        document.execCommand('copy');
        markCopied();
      }
    },
    openbusiness: function(tcdata) {
      const querystring = require('querystring');
      console.log(tcdata);
      this.modals.editbusiness = true;
      this.modals.item_name = tcdata.item_name;
      this.modals.item_name_ar = tcdata.item_name_ar;
      this.modals.item_description_ar = tcdata.item_description_ar;
      this.modals.item_description = tcdata.item_description;
      this.modals.item_visibility = tcdata.item_visibility;
      this.modals.item_category =
        tcdata.item_category._id +
        '#' +
        tcdata.item_category.business_category_name;
      this.modals.item_space = tcdata.item_space;
      this.modals.item_brand = tcdata.item_brand;
      this.modals.item_cost = tcdata.item_cost;
      this.modals.item_theme_color = tcdata.item_theme_color;
      if (tcdata.item_tags.length > 0) {
        this.modals.item_tags = tcdata.item_tags.toString();
      }
      this.modals.item_img = tcdata.item_img;
      this.modals.item_mentions = tcdata.item_mentions;
      this.modals.created_by = tcdata.created_by._id;
      this.modals.status = tcdata.status;

      this.modals.item_id = tcdata.item_id;

      console.log(this.modals);
    },
    getMultipleSubcategories() {
      // Clear existing subcategories when categories change
      this.subcategories = [];
      this.modals.selected_subcategories = [];

      if (this.modals.selected_categories.length === 0) {
        return;
      }

      // Fetch subcategories for all selected categories
      const promises = this.modals.selected_categories.map((categoryId) => {
        return axios.post(
          process.env.VUE_APP_API_ENDPOINT + 'read_business_subcategory',
          { business_category_oid: categoryId },
          this.auth
        );
      });

      Promise.all(promises).then((responses) => {
        // Combine all subcategories, avoiding duplicates
        const uniqueSubcategories = new Map();

        responses.forEach((response) => {
          if (response.data.details) {
            response.data.details.forEach((subcategory) => {
              uniqueSubcategories.set(subcategory._id, subcategory);
            });
          }
        });

        this.subcategories = Array.from(uniqueSubcategories.values());
        this.filtercategorybusiness();
      });
    },

    getCategoryName(categoryId) {
      const category = this.categories.find((c) => c._id === categoryId);
      return category ? category.business_category_name : 'Unknown';
    },

    getCategoriesByType(type) {
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_category', {
          status: 'approved',
          business_type: type,
        })
        .then((response) => {
          if (response.data.details) {
            console.log('type', type);
            console.log('available categories', response.data.details);
            const currentCategory =
              type === 'Designer'
                ? response.data.details.filter(
                    (item) =>
                      item.business_category_name ===
                      'Architectural & Engineering Consultancy'
                  )
                : type === 'Supplier'
                ? response.data.details.filter(
                    (item) =>
                      item.business_category_name !==
                      'Architectural & Engineering Consultancy'
                  )
                : response.data.details;
            console.log('curent categories', currentCategory);
            // Force reactivity by creating a new array reference
            this.categories = [...currentCategory];
            // OR use Vue.set if you're using Vue 2
            // this.$set(this, 'categories', response.data.details);
          } else {
            this.categories = [];
          }
          // Force re-render if needed
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        });
    },

    getSubcategoryName(subcategoryId) {
      const subcategory = this.subcategories.find(
        (s) => s._id === subcategoryId
      );
      return subcategory ? subcategory.business_subcategory_name : 'Unknown';
    },
    toggleCategorySelection(categoryId) {
      // Check if category is already selected
      const index = this.modals.selected_categories.indexOf(categoryId);

      if (index === -1) {
        // Add category if not already selected
        this.modals.selected_categories.push(categoryId);
      } else {
        // Remove category if already selected
        this.modals.selected_categories.splice(index, 1);
      }

      // Update subcategories when categories change
      this.getMultipleSubcategories();
    },
    toggleBusinessCategorySelection(categoryId) {
      // Check if category is already selected
      const index = this.model.business_categories.indexOf(categoryId);

      if (index === -1) {
        // Add category if not already selected
        this.model.business_categories.push(categoryId);
      } else {
        // Remove category if already selected
        this.model.business_categories.splice(index, 1);
      }

      // Update subcategories when categories change
      this.getMultipleSubcategoriesForNewBusiness();
    },
    removeBusinessCategory(categoryId) {
      const index = this.model.business_categories.indexOf(categoryId);
      if (index !== -1) {
        this.model.business_categories.splice(index, 1);
        this.getMultipleSubcategoriesForNewBusiness();
      }
    },

    removeCategory(categoryId) {
      const index = this.modals.selected_categories.indexOf(categoryId);
      if (index !== -1) {
        this.modals.selected_categories.splice(index, 1);
        this.getMultipleSubcategories();
      }
    },

    removeSubcategory(subcategoryId) {
      const index = this.modals.selected_subcategories.indexOf(subcategoryId);
      if (index !== -1) {
        this.modals.selected_subcategories.splice(index, 1);
        this.filterbusiness();
      }
    },

    getsubcategories(event) {
      const querystring = require('querystring');

      // Update selected_categories array with the selected category
      if (this.modals.business_category) {
        this.modals.selected_categories = [this.modals.business_category];
      } else {
        this.modals.selected_categories = [];
      }

      this.filtercategorybusiness();
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_business_subcategory',
          querystring.stringify({
            business_category_oid: this.modals.business_category,
          }),
          this.auth1
        )
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.subcategories = response.data.details;
            //this.model.category_name=response.data.subcategory_data[0].category_name;
          }
        });
    },
    isValidusername() {
      const querystring = require('querystring');
      // Usernames are stored lowercase for uniformity.
      this.model.user_name = (this.model.user_name || '').toLowerCase();
      console.log(this.model.user_name.length);
      if (this.model.user_name.length < 4) {
        this.usernamelength = true;
        this.username = false;
        this.specialcharacter = false;
      } else if (!/^[a-zA-Z0-9._]+$/.test(this.model.user_name)) {
        this.usernamelength = false;
        this.username = false;
        this.specialcharacter = true;
      } else {
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + 'search_business_user_name',
            { user_name: this.model.user_name },
            this.auth
          )
          .then((response) => {
            console.log(response);
            if (response.data.details) {
              this.username = true;
              this.usernamelength = false;
              this.specialcharacter = false;
              //this.model.category_name=response.data.subcategory_data[0].category_name;
            } else {
              this.username = false;
              this.usernamelength = false;
              this.specialcharacter = false;
            }
          });
      }
    },
    isValidEmail() {
      // Regular expression for a valid email pattern
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      // Use the test() method to check if the email matches the pattern
      emailPattern.test(this.model.user_email)
        ? (this.emailValid = true)
        : (this.emailValid = false);
    },
    getMultipleSubcategoriesForNewBusiness() {
      // Clear existing subcategories when categories change
      this.subcategories = [];
      this.model.business_subcategories = [];

      if (this.model.business_categories.length === 0) {
        return;
      }

      // Fetch subcategories for all selected categories
      const promises = this.model.business_categories.map((categoryId) => {
        return axios.post(
          process.env.VUE_APP_API_ENDPOINT + 'read_business_subcategory',
          { business_category_oid: categoryId },
          this.auth
        );
      });

      Promise.all(promises).then((responses) => {
        // Combine all subcategories, avoiding duplicates
        const uniqueSubcategories = new Map();

        responses.forEach((response) => {
          if (response.data.details) {
            response.data.details.forEach((subcategory) => {
              uniqueSubcategories.set(subcategory._id, subcategory);
            });
          }
        });

        this.subcategories = Array.from(uniqueSubcategories.values());
      });
    },
    updatebusiness() {
      console.log(this.modals);
      let tags = [];
      if (this.modals.item_category) {
        let item_category = this.modals.item_category.split('#');
        this.modals.item_category = item_category[0];
      }
      const querystring = require('querystring');
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'update_business',
          querystring.stringify({
            item_id: this.modals.item_id,
            item_name: this.modals.item_name,
            item_name_ar: this.modals.item_name_ar,
            item_description: this.modals.item_description,
            item_tags: this.modals.item_tags,
            item_type: this.modals.item_type,
            item_visibility: this.modals.item_visibility,
            item_category: this.modals.item_category,
            item_subcategory: this.modals.item_subcategory,
            item_cost: this.modals.item_cost,
            created_by: this.modals.created_by,
            status: this.modals.status,
          }),
          this.auth1
        )
        .then((response) => {
          console.log(response);
          this.message = response.data.message;
          document.getElementById('updatebtn1').classList.remove('btn-primary');
          document.getElementById('updatebtn1').classList.add('btn-success');
          document.getElementById('updatebtn1').innerHTML = 'Updated';
          setTimeout(function() {
            document
              .getElementById('updatebtn1')
              .classList.remove('btn-success');
            document.getElementById('updatebtn1').classList.add('btn-primary');
            document.getElementById('updatebtn1').innerHTML = 'Update';
            window.location.reload();
          }, 2000);
        });
    },

    previouspage() {
      console.log(this.auth);
      if (this.offset >= 0) {
        --this.offset;
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
            details: { user_type: 'Business' },
            offset: this.offset,
          })
          .then((response) => {
            console.log(response);
            if (response.data.details) {
              this.businessData = response.data.details;
            }
          });
      }
    },
    gotopage() {
      const querystring = require('querystring');
      console.log(this.auth);
      if (document.getElementById('page_no').value) {
        this.offset = document.getElementById('page_no').value;
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
            details: { user_type: 'Business' },
            offset: this.offset,
          })
          .then((response) => {
            console.log(response);
            if (response.data.details) {
              this.businessData = response.data.details;
            }
          });
      }
    },
    nextpage() {
      this.offset = this.offset + 1;
      const querystring = require('querystring');
      console.log(this.auth);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
          details: { user_type: 'Business' },
          offset: this.offset,
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.businessData = response.data.details;
          }
        });
    },
    searchbusiness() {
      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
          details: { user_type: 'Business' },
          offset: '0',
          search_type: 'search_business',
          offset: '0',
          search_term: this.search,
          business_name_english: this.search,
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.sdeleteitem = false;
            this.searchData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.searchData = [];
            this.sdeleteitem = true;
          }
        });
    },
    filterbusiness() {
      const querystring = require('querystring');

      // Update selected_subcategories array with the selected subcategory
      if (this.modals.business_subcategory) {
        this.modals.selected_subcategories = [this.modals.business_subcategory];
      } else {
        this.modals.selected_subcategories = [];
      }

      // Build filter query with arrays of categories and subcategories
      const filterDetails = {
        user_type: 'Business',
      };

      if (this.modals.selected_categories.length > 0) {
        filterDetails.business_category = this.modals.selected_categories;
      }

      if (this.modals.selected_subcategories.length > 0) {
        filterDetails.business_subcategory = this.modals.selected_subcategories;
      }

      if (this.modals.business_city) {
        filterDetails.business_city = this.modals.business_city;
      }

      console.log('Filter Details:', filterDetails);

      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
          offset: '0',
          details: filterDetails,
        })
        .then((response) => {
          console.log('Filter Response:', response);
          if (response.data.details) {
            this.deleteitem = false;
            this.businessData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.businessData = [];
            this.deleteitem = true;
          }
        });
    },

    filtercategorybusiness() {
      if (this.modals.selected_categories.length === 0) {
        return this.cleardata();
      }

      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
          offset: '0',
          details: {
            user_type: 'Business',
            business_category: this.modals.selected_categories,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.deleteitem = false;
            this.businessData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.businessData = [];
            this.deleteitem = true;
          }
        });
    },

    filtercitybusiness() {
      console.log(this.modals.item_brand);
      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
          offset: '0',
          details: {
            user_type: 'Business',
            business_city: this.modals.business_city,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.deleteitem = false;
            this.businessData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.businessData = [];
            this.deleteitem = true;
          }
        });
    },

    cleardata() {
      this.modals.selected_categories = [];
      this.modals.selected_subcategories = [];
      this.modals.business_category = '';
      this.modals.business_subcategory = '';
      this.modals.business_city = '';
      this.modals.filter_business_type = '';
      this.subcategories = [];

      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_all', {
          details: { user_type: 'Business' },
          offset: '0',
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.businessData = response.data.details;
            this.deleteitem = false;
          }
        });
    },
    resetForm() {
      // Reset all form fields to initial state
      this.model = {
        item_name: '',
        item_name_ar: '',
        item_description_ar: '',
        item_description: '',
        item_type: 'business',
        user_status: '',
        item_visibility: 'Public',
        item_category: '',
        item_subcategory: '',
        item_space: '',
        item_brand: '',
        item_cost: '',
        item_theme_color: '',
        item_tags: '',
        optype: 'Add',
        item_img: '',
        item_mentions: '',
        item_rate: '',
        created_by: '',
        status: '',
        user_email: '',
        user_password: '',
        cuser_password: '',
        user_name: '',
        user_businessname: '',
        user_country: localStorage.getItem('country_name'),
        user_businessdescription: '',
        user_businessemail: '',
        user_businessnamearabic: '',
        user_businessdescriptionarabic: '',
        business_category: '',
        business_subcategory: '',
        user_businessaddressenglish: '',
        user_businessaddressarabic: '',
        business_city: '',
        business_type: '',
        user_phone: '',
        user_website: '',
        cuser_facebook: '',
        user_instagram: '',
        user_youtube: '',
        user_twitter: '',
        user_whatsapp: '',
        logo: '',
        cover_image: '',
        gpslink: '',
      };

      // Reset hours arrays - Sunday first order
      this.business_hours = [
        {
          day: 'Sun',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Mon',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Tue',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Wed',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Thu',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Fri',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Sat',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
      ];

      this.leisure_hours = [
        {
          day: 'Sun',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Mon',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Tue',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Wed',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Thu',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Fri',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Sat',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
      ];

      // Clear upload previews
      this.uploadPercentage = 0;
    },
    refreshBusinessList() {
      // Refresh the business list from the server
      const querystring = require('querystring');
      console.log('Refreshing business list...');

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_business_all',
          {
            details: { user_type: 'Business' },
          },
          this.auth
        )
        .then((response) => {
          console.log('Business list refreshed:', response.data);
          if (response.data.details) {
            this.businessData = response.data.details;
          }
        })
        .catch((error) => {
          console.error('Error refreshing business list:', error);
        });
    },
  },
};
</script>

<style>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}

.business-image {
  max-height: 200px;
  overflow: hidden;
}

.business-image img {
  min-height: 200px;
}

.select-day {
  display: table-cell;
  text-align: center;
}

.days {
  border: 1px solid #ccc;
  padding: 8px 23px;
  border-radius: 1.375rem;
  background-color: #f7f7f7;
}

.days.active {
  background: #00b4db;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #0083b0, #00b4db);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #0083b0, #00b4db);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
  border: none;
}

.vue__time-picker {
  width: 100%;
  -webkit-box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15),
    0 1px 0 rgba(0, 0, 0, 0.02);
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  -webkit-transition: -webkit-box-shadow 0.15s ease;
  transition: -webkit-box-shadow 0.15s ease;
  transition: box-shadow 0.15s ease;
  transition: box-shadow 0.15s ease, -webkit-box-shadow 0.15s ease;
  border-radius: 0.375rem;
}

.vue__time-picker input.display-time .is-empty {
  width: 100%;
  border-color: transparent;
  padding: 1.2em 0.5em;
  border-radius: 2.3rem;
}

/* Google Maps Style Hours Interface */
.google-hour-row {
  transition: background-color 0.2s ease;
  border: 1px solid transparent;
}

.google-hour-row:hover {
  background-color: #f8f9fa !important;
  border-color: #e9ecef;
}

.closed-day-row {
  background-color: #f8f9fa !important;
  border-left: 4px solid #dc3545 !important;
  opacity: 0.7;
}

.closed-day-row .day-name span {
  text-decoration: line-through;
}

.closed-text {
  font-size: 14px;
}

.cursor-pointer {
  cursor: pointer;
}

.day-name {
  min-width: 120px;
  font-size: 15px;
  font-weight: 600;
}

.time-controls {
  flex: 1;
  justify-content: center;
}

.time-input-group {
  min-width: 110px;
}

.google-time-picker {
  border: none !important;
  box-shadow: none !important;
}

.google-time-input {
  background-color: #f8f9fa !important;
  border: 1px solid #e9ecef !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 10px 15px !important;
  transition: all 0.2s ease !important;
  min-width: 100px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.google-time-input:focus {
  border-color: #4285f4 !important;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1) !important;
  background-color: #fff !important;
}

.add-hours-btn {
  white-space: nowrap;
  font-weight: 500;
}

.add-hours-btn:hover {
  text-decoration: none !important;
  color: #1a73e8 !important;
}

.closed-toggle {
  min-width: 90px;
}

.closed-toggle .custom-control-label {
  font-size: 13px;
  color: #5f6368;
  font-weight: 500;
}

.hours-container {
  max-width: 900px;
  margin: 0 auto;
}

/* Custom Switch Styling */
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #4285f4 !important;
  border-color: #4285f4 !important;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #4285f4 !important;
  border-color: #4285f4 !important;
}

/* Primary color for business hours */
.bg-gradient-primary {
  background: linear-gradient(135deg, #4285f4 0%, #1a73e8 100%) !important;
}

.text-primary {
  color: #4285f4 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .google-hour-row {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 12px;
  }

  .time-controls {
    width: 100%;
    justify-content: flex-start;
  }

  .closed-toggle {
    width: 100%;
  }

  .day-name {
    min-width: auto;
    font-weight: 600;
  }

  .google-time-input {
    min-width: 80px !important;
  }
}

/* Enhanced Time Management Styles */
.hover-lift {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.hover-lift:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0, 180, 148, 0.15) !important;
}

.time-config-section .input-group-text {
  border-radius: 8px 0 0 8px;
  border: none;
}

.time-config-section .form-control {
  border-radius: 0 8px 8px 0;
  border: 1px solid #e3e6f0;
  transition: all 0.3s ease;
}

.time-config-section .form-control:focus {
  border-color: #00b894;
  box-shadow: 0 0 0 0.2rem rgba(0, 184, 148, 0.25);
}

.closed-day-section {
  transition: all 0.3s ease;
}

.closed-day-section:hover {
  background-color: rgba(0, 184, 148, 0.05);
  border-radius: 8px;
  padding: 8px;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #00b894;
  border-color: #00b894;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #00b894;
  border-color: #00b894;
}

.bg-gradient-success {
  background: linear-gradient(135deg, #00d4aa 0%, #00b894 100%) !important;
}

.alert-danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
  color: white;
}

.badge-warning {
  background: linear-gradient(45deg, #feca57, #ff9ff3);
  color: white;
}

.form-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}

/* Brand Color Overrides */
.text-success {
  color: #00b894 !important;
}

.badge-success {
  background-color: #00b894 !important;
}

.border-left-primary {
  border-left: 4px solid #00b894 !important;
}

.border-left-success {
  border-left: 4px solid #00b894 !important;
}

.bg-opacity-20 {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.bg-opacity-10 {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.font-weight-800 {
  font-weight: 800 !important;
}

.form-group {
  margin-bottom: 1rem;
}

.custom-control-label {
  cursor: pointer;
}

.badge {
  cursor: default;
  font-weight: 400;
  padding: 6px 8px;
}

.badge i {
  cursor: pointer;
  opacity: 0.7;
}

.badge i:hover {
  opacity: 1;
}

.cursor-pointer {
  cursor: pointer;
}
/* Scrollable category/subcategory lists */
.form-group {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 10px;
}

.form-group::-webkit-scrollbar {
  width: 6px;
}

.form-group::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0.375rem;
}

.form-group::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 0.375rem;
}

.form-group::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .hover-lift:hover {
    transform: none;
  }

  .card-body {
    padding: 1.5rem !important;
  }

  .time-config-section .row {
    margin: 0;
  }
}
</style>
